import { useCallback, useEffect, useState } from 'react';
import PrintFiles from 'pages/Ai/PrintFiles';

import DragAndDrop from 'components/common/DragAndDrop/DragAndDrop';

interface Props {
  onChange: (prop: string, value: any) => void;
}
const StepTwo = ({ onChange }: Props) => {
  const [files, setFiles] = useState([]);
  const removeFile = useCallback((index: number) => {
    setFiles(obj => obj.filter((_, i) => i !== index));
  }, []);
  useEffect(() => {
    onChange('files', files);
  }, [files]);
  return (
    <div>
      <div className="m-1" />
      <DragAndDrop
        variaty="multiple"
        accept=".pdf,.doc,.docx"
        onDrop={dropped => {
          setFiles(val => [...val, ...dropped]);
        }}
      />

      <div className="topGreyBorder  m-1" />
      {files.length > 0 && (
        <div>
          {files.map((file, index) => (
            <PrintFiles file={file} key={index} removeFile={() => removeFile(index)} />
          ))}
        </div>
      )}
    </div>
  );
};

export default StepTwo;
